import { Typography } from "@mui/material";
import { alpha, styled, Theme } from "@mui/material/styles";

export const mentionTagStyles = (theme: Theme) => ({
  backgroundColor: alpha(theme.palette.node.prompt.light, 0.2),
  borderRadius: 4,
  boxDecorationBreak: "clone" as const,
  color: theme.palette.node.prompt.light,
  padding: theme.spacing(0.5, 0.5),
  fontWeight: 500,
});

export const MentionTag = styled(Typography)(({ theme }) =>
  mentionTagStyles(theme),
);
